import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Stack,
  Radio,
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Snackbar,
  Alert,
} from "@mui/material";
import generateTimeRanges from "./TimeSelect";

import { Header, MainColorButton, Pulldown } from "../../components";
import { bottomButton } from "../../common/styles";
import { INSURANCE_INFORMATION } from "../../routes/path";
import store from "../../store";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setPrescriptionReservation } from "../../store/actions/prescription";
import { format } from "date-fns";

/**
 * 処方箋申込[服薬指導予約]
 * @returns
 */
const PrescriptionReservation = () => {
  const [endY, setEndY] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  //エラーメッセージ表示
  const [openSnackbar, setOpenSnackbar] = useState({
    status: false,
    message: "",
  });
  const handleSnackbarClose = () => {
    setOpenSnackbar({
      status: false,
      message: "",
    });
  };

  const [selectedDate, setSelectedDate] = useState(new Date());
  const weekList = location.state.weekList;
  const day = selectedDate.getDay();
  const week = ["日", "月", "火", "水", "木", "金", "土"];
  const getOfWeek = week[day];
  const targetDate = weekList.filter((item) => item.weekName === getOfWeek);
  const [reservation, setReservation] = useState("0");
  const [time, setTime] = useState("");
  const [formatTime, setFormatTime] = useState(time.substring(0, 5));
  const timeRanges = generateTimeRanges(
    selectedDate,
    targetDate[0].openTime,
    targetDate[0].closeTime
  ).map((range, index) => ({
    id: index.toString(),
    value: range,
  }));
  const minDate = new Date();
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 2);
  // 日付選択処理
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  //  予約日時に渡す値
  const [reservationDate, setReservationDate] = useState(
    new Date(format(selectedDate, "yyyy-MM-dd") + " " + formatTime)
  );

  const [nextBtnDisable, setNextBtnDisable] = useState(false);
  // 処方箋受付 服薬指導種別
  useEffect(() => {
    setFormatTime(time.substring(0, 5));
  }, [time]);

  useEffect(() => {
    setReservationDate(
      new Date(format(selectedDate, "yyyy-MM-dd") + " " + formatTime)
    );
  }, [formatTime]);

  useEffect(() => {
    setReservationDate(null);
    store.dispatch(
      setPrescriptionReservation({
        id: reservation,
      })
    );
  }, []);

  useEffect(() => {
    if (reservation === "0") {
      setNextBtnDisable(false);
    }
    if (reservation === "1" && !reservationDate) {
      setNextBtnDisable(true);
    }
  }, [reservation]);

  useEffect(() => {
    if (reservationDate) {
      setNextBtnDisable(false);
    }
  }, [reservationDate]);

  useEffect(() => {
    if (timeRanges.length > 0) {
      if (time) {
        let timeList = timeRanges.find((item) => item.value === time);
        if (timeList && timeList.length > 0) {
          setFormatTime(time.substring(0, 5));
        } else {
          setTime(timeRanges[0].value);
        }
      } else {
        setTime(timeRanges[0].value);
      }
    } else {
      setReservationDate(null);
    }
  }, [selectedDate]);

  return (
    <>
      <div
        onTouchStartCapture={(e) => {
          setEndY(0);
        }}
        onTouchMoveCapture={(e) => {
          setEndY(e.touches[0].clientY);
        }}
        onTouchEndCapture={(e) => {
          if (endY !== 0) {
            e.stopPropagation();
          }
        }}
      >
        <Header title="処方箋申込[服薬指導予約]" />
        <Snackbar
          open={openSnackbar.status}
          autoHideDuration={5000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleSnackbarClose}
          sx={{ mt: "8vh" }}
        >
          <Alert
            severity="error"
            sx={{ width: "100%" }}
            onClose={handleSnackbarClose}
          >
            {openSnackbar.message}
          </Alert>
        </Snackbar>
        <Box
          height="76vh"
          marginTop="9vh"
          width="95%"
          marginLeft="auto"
          marginRight="auto"
        >
          <Stack>
            <Typography variant="subtitle1" align="justify">
              お薬の準備が整いましたら、お薬説明のためのビデオチャットURLをお送りします。
              <br />
              お薬の説明を希望する時間帯を入力ください。
            </Typography>
            <Box
              width="85%"
              marginLeft="auto"
              marginRight="auto"
              marginTop="5%"
            >
              <FormControl fullWidth>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={reservation}
                  onChange={(event) => {
                    setReservation(event.target.value);
                    store.dispatch(
                      setPrescriptionReservation({
                        id: event.target.value,
                      })
                    );
                  }}
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="指定なし"
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="指定あり"
                  />
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box width="19%">
                      <Typography textAlign="right">日付</Typography>
                    </Box>
                    <Box width="70%">
                      <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                      >
                        <FormControl fullWidth>
                          <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="yyyy年MM月dd日"
                            minDate={minDate}
                            maxDate={maxDate}
                            isClearable={false}
                            disabled={reservation === "0"}
                          />
                        </FormControl>
                      </Stack>
                    </Box>
                  </Stack>
                  <Stack
                    direction="row"
                    spacing={2}
                    marginTop="2%"
                    alignItems="center"
                  >
                    <Box width="19%">
                      <Typography textAlign="right">時間</Typography>
                    </Box>
                    <Box width="70%">
                      <FormControl fullWidth>
                        <Pulldown
                          size="small"
                          withLabel={false}
                          withMenuProps={true}
                          items={timeRanges}
                          value={time}
                          setValue={setTime}
                          valueProps={true}
                          disabled={reservation === "0"}
                        />
                      </FormControl>
                    </Box>
                  </Stack>
                </RadioGroup>
              </FormControl>
            </Box>
          </Stack>
        </Box>
        <MainColorButton
          label="次へ"
          onClick={() => {
            if (reservation !== "0") {
              let msg = "";
              if (reservationDate == null) {
                msg = "時間を選択してください。";
              } else if (reservationDate <= new Date()) {
                msg = "服薬指導の予約は現在時刻以降にしてください。";
              }
              if (msg) {
                setOpenSnackbar({
                  status: true,
                  message: msg,
                });
                return;
              }
            }

            // 時間を予約しない場合は、時間を選択してもnullを後ろに転送する
            navigate(INSURANCE_INFORMATION, {
              state: {
                reservationDate: reservation === "0" ? null : reservationDate,
              },
            });
          }}
          style={bottomButton}
          disabled={nextBtnDisable}
        />
      </div>
    </>
  );
};

export default PrescriptionReservation;
